import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import TrustBadges from './components/TrustBadges';
import About from './components/About';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import GovernmentCredibility from './components/GovernmentCredibility';
import Contact from './components/Contact';
import WhatsAppButton from './components/WhatsAppButton';
import LoginPage from './pages/LoginPage';
import AdminPage from './pages/AdminPage';

// Home page component
function HomePage() {
  return (
    <div className="App">
      <Toaster position="top-right" />
      <Header />
      <Hero />
      <TrustBadges />
      <About />
      <Services />
      <Portfolio />
      <GovernmentCredibility />
      <Contact />
      <WhatsAppButton />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </Router>
  );
}

export default App;